import { Routes } from '@angular/router';
import { NewOrganisationComponent } from './new-organisation/new-organisation.component';
import { OrganisationsListComponent } from './organisations-list/organisations-list.component';

export const organisationRouts: Routes = [
  { path: 'organisations/list/:parentOrganisationId', component: OrganisationsListComponent },
  { path: 'organisations/:mode/:organisationId', component: NewOrganisationComponent },
  { path: 'organisations/list', component: OrganisationsListComponent },
];
